<script>
	/*
		TCareDate.svelte
	*/

	// import { Datepicker } from 'svelte-calendar';
	import { DateInput } from 'date-picker-svelte'

    // SMUI components
	import { Icon } from '@smui/icon-button';
	import { Svg } from '@smui/common/elements';
	import { mdiCalendarBlankOutline } from '@mdi/js';

	let inputRef;					// for focusing on the Date input

	export let source;
	export let prop;
	export let placeholder;
	// export let setValue;			// no setValue due to binding the <DateInput>


	// TODO: focus on the input when calendar icon is clicked!
	const _onCalendarClick = (e) => {
		// console.log('_onCalendarClick');
		// console.log(inputRef);				// CRASH!
		// inputRef.focus();
	}

</script>

<style>
	/* in tcare-ui.css */
</style>

<div class="tcui-control flex-row date-wrapper">
	<Icon component={Svg} viewBox="0 0 24 24" on:click={_onCalendarClick}>
		<path d={mdiCalendarBlankOutline} >
	</Icon>	
	<DateInput 
		bind:value={source[prop]} 
		closeOnSelection={true}
		format={'MM-dd-yyyy'}
		placeholder={placeholder}
		bind:this={inputRef}
	/>
</div>
